import { makeStyles } from '@mui/styles'
import { NEON_BLUE_LIGHT } from '@returnmates/client-core/src/constants/colors'

const useStyles = makeStyles(() => ({
  main: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
  },
  checked: {
    '&.Mui-checked': {
      color: NEON_BLUE_LIGHT,
      '&:hover': {
        backgroundColor: 'rgba(99, 93, 246, 0.1)',
      },
    },
  },
  root: {},
  input: {},
}))

export default useStyles
